import { render, staticRenderFns } from "./QualityExecutionDetailComponent.vue?vue&type=template&id=6b414f60&lang=pug"
import script from "./QualityExecutionDetailComponent.vue?vue&type=script&lang=js"
export * from "./QualityExecutionDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b414f60')) {
      api.createRecord('6b414f60', component.options)
    } else {
      api.reload('6b414f60', component.options)
    }
    module.hot.accept("./QualityExecutionDetailComponent.vue?vue&type=template&id=6b414f60&lang=pug", function () {
      api.rerender('6b414f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality_dataplex/components/QualityExecutionDetailComponent.vue"
export default component.exports